import { combineReducers } from "redux";
import { Configuration, employeeReducer, task, teamManagementReducer } from "./reducers";
const reducers = combineReducers({
    allEmployee: employeeReducer,
    team: teamManagementReducer,
    configuration: Configuration,
    task: task
});
export default reducers